import {getId} from 'apis/model/base'
import useTranslate from 'modules/local/useTranslate'
import React, {useCallback, useContext, useMemo} from 'react'
import {NullAsDefault, pagerControls, renderSelf} from 'views/Shared'
import {organization_group_getGroupMembers_Api} from "../../../apis";
import _ from "lodash";
import {useOrganizationGroupForm} from "../../AppLocals/Organization/functions/useOrganizationGroupForm";
import {ActionModalWrapper} from "../../../components/form/ActionModalWrapper";
import {ListHeaderLineAndDes} from "../../AppLocals/Templates/items/ListHeader";
import EntityList from "../../AppLocals/EntityList";
import {bindQueryParam} from "../../AppLocals/functions/routerHelper";
import createContextMenu from "../../AppLocals/factory/createContextMenu";
import {BiSolidEdit, BiTrash} from "react-icons/bi";
import {OrganizationActionTypes} from "../Host/WorkspaceMembers";
import WorkspaceContext from "../WorkspaceContext";
import getAvatar from "../../../helpers/getAvatar";
import {FaUserTie} from "react-icons/fa6";
import {Avatar} from "antd";
import {ItemInformation} from 'components/common/ItemInformation'
import {formatSimplifyDate} from "../../../helpers/dateUtils";
import {DoubleValueItem} from 'components/common/DoubleValueItem'
import {HiBriefcase} from "react-icons/hi2";
import {MemberContextActionTypes, useMemberForm} from "../../MemberSetting/useMemberForm";
import {MdOutlineAssignmentTurnedIn} from "react-icons/md";
import {GiCardExchange} from "react-icons/gi";
import {BsInboxesFill, BsXCircle} from "react-icons/bs";
import {LoginContext} from "../../../components/LoginContext";
import {roleIds} from "../../../modules/permissions/contants";


const renderDepartmentMember = ({t, renderContextMenu = NullAsDefault} = {}) => (item, index) => {

    const {
        user,
        name,
        role_title,
        contact_email,
        contact_phone,
        date_of_birth,
        from_date, to_date,
        patron_saint_name,
    } = item ?? {}

    return (
        <div
            key={item.id}
            className="p-3 flex flex-col border border-color-50 shadow-md rounded-xl hover:scale-102 custom-item-render relative">
            <div className="mb-2 pb-2 border-b border-color-100 flex items-center gap-2">
                <Avatar
                    size={42}
                    className="flex flex-center background-200"
                    src={getAvatar(item) || user?.avatar}
                    icon={<FaUserTie size={20} className="text-color-500"/>}
                />
                <div className="flex flex-col flex-1">
                    <h2 className="font-bold text-base text-color-000 hover:text-primary cursor-pointer leading-snug">
                        {patron_saint_name ? patron_saint_name : ''} {name}
                    </h2>
                    <div className="flex items-center justify-between">
                        {role_title && (
                            <div className="flex items-center gap-2 leading-tight">
                                <HiBriefcase size={12} className="text-indigo-300"/>
                                <span
                                    className="flex-1 font-bold text-xs text-indigo-600 tracking-wider">{role_title}</span>
                            </div>
                        )}
                        {item?.role_id && [1, 2].includes(item?.role_id) && (
                            <span className="font-medium text-xs text-secondary-500 italic tracking-wide">{t(roleIds[item?.role_id])}</span>
                        )}
                    </div>
                </div>
            </div>
            <div className="ml-3 flex flex-col flex-1 gap-1">
                <DoubleValueItem
                    primary={true}
                    showIcon={true}
                    labelFirst="joined on"
                    valueFirst={formatSimplifyDate(from_date, 'medium')}
                    labelSecond={to_date ? 'to date' : ''}
                    valueSecond={formatSimplifyDate(to_date, 'medium')}
                    className="text-xs"
                />
                <ItemInformation
                    showIcon={true}
                    label="phone"
                    value={contact_phone}
                    className="text-xs"
                />
                <ItemInformation
                    showIcon={true}
                    label="email"
                    value={contact_email}
                    className="text-xs"
                />
                <ItemInformation
                    showIcon={true}
                    label="date of birth"
                    value={formatSimplifyDate(date_of_birth, 'medium')}
                    className="text-xs"
                />
            </div>
            {_.isFunction(renderContextMenu) && (
                <div className="absolute right-5 top-5 contextIcon">
                    {renderContextMenu(item)}
                </div>
            )}
        </div>
    )
}

export const WorkspaceOrganizationGroupMemberList = ({
                                                              item,
                                                              header = null,
                                                              controls = pagerControls,
                                                              renderFooter = renderSelf,
                                                              refreshToken
                                                          }) => {
    const t = useTranslate()
    const apiInfo = organization_group_getGroupMembers_Api
    const {keyword, component: search_widget} = controls?.search ?? {}
    const group_id = getId(item)
    const {organization} = useContext(WorkspaceContext)
    const login = useContext(LoginContext)

    const {
        modal,
        action,
        onCancel,
        handleAction,
        refreshToken: refreshToken2
    } = useOrganizationGroupForm({organization})

    const {
        modal: memberModal,
        handleAction: handleMemberAction,
        refreshKey: refreshMemberKey
    } = useMemberForm({owner: item})

    const refreshKey = useMemo(
        () =>
            [
                apiInfo.path.replace(':id', group_id),
                JSON.stringify(keyword),
                refreshMemberKey, refreshToken, refreshToken2
            ].join(','),
        [group_id, keyword, refreshMemberKey, refreshToken, refreshToken2]
    )

    const renderContextMenu = useCallback(
        (item) =>
            createContextMenu(
                [
                    {
                        icon: <BiSolidEdit size={14} className="text-blue-500"/>,
                        label: 'update',
                        key: OrganizationActionTypes.DEPT_EDIT_MEMBER,
                    },
                    {
                        icon: <MdOutlineAssignmentTurnedIn size={14} className="text-green-500"/>,
                        label: 'assign role',
                        key: MemberContextActionTypes.ASSIGN_MEMBER_ROLE,
                        scope: "member"
                    },
                    {
                        icon: <GiCardExchange size={14} className="text-blue-500"/>,
                        label: 'assign member as owner role',
                        key: MemberContextActionTypes.ASSIGN_MEMBER_AS_OWNER_ROLE,
                        visible: (item) => item?.role_id !== 1 && item?.user?.id !== login?.id
                    },
                    {
                        icon: <BsXCircle size={14} className="text-orange-500"/>,
                        label: 'revoke role',
                        key: MemberContextActionTypes.REVOKE_MEMBER_ROLE,
                        visible: (item) => item?.role_id !== 1 && item?.role_id !== 3 && item?.user?.id !== login?.id
                    },
                    {
                        icon: <BiTrash size={14} className="text-primary-300"/>,
                        label: 'delete',
                        key: OrganizationActionTypes.DEPT_DELETE_MEMBER,
                        scope: "dept_member"
                    },
                ].filter((e) => item)
                    .filter(({visible = ((e) => true)}) => visible(item)),
                (key) => {
                    switch (key) {
                        case OrganizationActionTypes.DEPT_EDIT_MEMBER:
                        case OrganizationActionTypes.DEPT_DELETE_MEMBER:
                            handleAction(key, item)
                            break;
                        case MemberContextActionTypes.ASSIGN_MEMBER_ROLE:
                        case MemberContextActionTypes.ASSIGN_MEMBER_AS_OWNER_ROLE:
                        case MemberContextActionTypes.REVOKE_MEMBER_ROLE:
                            handleMemberAction(key, item)
                            break;
                        default:
                    }
                }
            ),
        [group_id]
    )


    return (
        <ActionModalWrapper className="flex-1">
            {header}
            <div className="flex flex-col gap-3 flex-1">
                {search_widget}
                <ListHeaderLineAndDes
                    renderTitle={() => (
                        <span className="font-semibold text-sm text-color-400 uppercase tracking-wider">
                            {t('list of members')}
                        </span>
                    )}
                    description="member of group description"
                />
                <EntityList
                    key={refreshKey}
                    apiInfo={apiInfo}
                    values={{keyword}}
                    refreshKey={refreshKey}
                    RenderEntity={React.Fragment}
                    query={bindQueryParam({id: group_id})}
                    renderItem={renderDepartmentMember({t, renderContextMenu, handleAction})}
                    renderWrap={(child) => (
                        <div className="grid grid-cols-1 md:grid-cols-2 gap-4">{child}</div>
                    )}
                    renderEmpty={() => (
                        <div
                            className="p-6 col-span-2 flex flex-col items-center gap-3 border border-color-50 rounded-xl shadow-md">
                            <BsInboxesFill size={40} style={{color: '#dedede'}}/>
                            <span className="text-center text-sm text-color-300 tracking-wider italic">
                                {t('no data is available now')}
                            </span>
                        </div>
                    )}
                />
            </div>
            {renderFooter(null)}
            {modal}
            {memberModal}
        </ActionModalWrapper>
    )
}
